import React, { useState, useEffect } from "react";
import axios from "axios";
import bcrypt from "bcryptjs";
import Sidebar from "../Misc/Sidebar";
import DashNavbar from "../Misc/DashNavbar";

function Create() {
  const [values, setValues] = useState({
    name: "",
    email: "",
    role: "",
    password: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State for password visibility

  // Clear form data on page refresh
  useEffect(() => {
    const clearFormData = () => {
      setValues({
        name: "",
        email: "",
        role: "",
        password: "",
      });
      setSuccessMessage("");
      setErrorMessage("");
    };

    // Clear form data when the component mounts (page refresh)
    clearFormData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMessage("");
    }, 3000);

    return () => clearTimeout(timer);
  }, [successMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Show loader

    try {
      const hashedPassword = await bcrypt.hash(values.password, 10);

      const response = await axios.post(
        "https://raasbackend.vetrinahealthcare.com/students/create/",
        {
          ...values,
          password: hashedPassword,
        }
      );

      console.log(response);
      setSuccessMessage("User added successfully");
      setErrorMessage("");
      // Clear all form fields after successful submission
      setValues({
        name: "",
        email: "",
        role: "",
        password: "",
      });
    } catch (err) {
      console.error(err);
      setSuccessMessage("");
      setErrorMessage("User already exists...");
    } finally {
      setIsLoading(false); // Hide loader
    }
  };

  // Function to validate name input
  const validateName = (name) => {
    // Regular expression to allow only alphabetic characters and spaces
    const regex = /^[A-Za-z\s]+$/;
    return regex.test(name);
  };

  const handleNameChange = (e) => {
    const inputValue = e.target.value;
    if (validateName(inputValue) || inputValue === "") {
      setValues({ ...values, name: inputValue });
    }
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <DashNavbar />
      <div className="wrapper">
        <Sidebar />
        <div className="main">
          <div
            className=" auth-inner d-flex bg-light my-element justify-content-center align-items-center mt-2"
            style={{ height: "80%", width: "40vw" }}
          >
            <div className="w-100 rounded p-3">
              <form onSubmit={handleSubmit}>
                <h2 style={{ marginBottom: "5%" }} className="gradient-text">
                  Add User
                </h2>
                {successMessage && (
                  <div className="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}
                {errorMessage && (
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                )}
                <div className="mb-3 d-flex flex-column align-items-start">
                  <label className="mb-1">Name</label>
                  <input
                    type="text"
                    placeholder="Enter name"
                    className="form-control"
                    value={values.name}
                    onChange={handleNameChange}
                    required
                  />
                </div>
                <div className="mb-3 d-flex flex-column align-items-start">
                  <label className="mb-1">Email</label>
                  <input
                    type="email"
                    placeholder="Enter email"
                    className="form-control"
                    value={values.email}
                    onChange={(e) =>
                      setValues({ ...values, email: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="mb-3 d-flex flex-column align-items-start">
                  <label className="mb-1">Password</label>
                  <div className="input-group w-100">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter password"
                      className="form-control"
                      value={values.password}
                      onChange={(e) =>
                        setValues({ ...values, password: e.target.value })
                      }
                      required
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={togglePasswordVisibility}
                      style={{
                        border: "1px solid #ced4da",
                        borderLeft: "none",
                      }}
                    >
                      <i
                        className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                      ></i>
                    </button>
                  </div>
                </div>
                <div className="mb-3 d-flex flex-column align-items-start">
                  <label className="mb-1">Role</label>
                  <select
                    className="form-select"
                    value={values.role}
                    onChange={(e) =>
                      setValues({ ...values, role: e.target.value })
                    }
                    required
                  >
                    <option value="">Select Role</option>
                    <option value="Admin">Admin</option>
                    <option value="HR">HR</option>
                    <option value="Candidate">Candidate</option>
                    <option value="Interviewer">Interviewer</option>
                  </select>
                </div>
                <button className="btn btn-success" disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Create;
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import bcrypt from "bcryptjs";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";

// function Create() {
//   const [values, setValues] = useState({
//     name: "",
//     email: "",
//     role: "",
//     password: "",
//   });

//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setSuccessMessage("");
//     }, 3000);

//     return () => clearTimeout(timer);
//   }, [successMessage]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const hashedPassword = await bcrypt.hash(values.password, 10);

//     axios
//       .post("https://raasbackend.vetrinahealthcare.com/students/create/", {
//         ...values,
//         password: hashedPassword,
//       })
//       .then((res) => {
//         console.log(res);
//         setSuccessMessage("User added successfully");
//         setErrorMessage("");
//         setValues({
//           name: "",
//           email: "",
//           role: "",
//           password: "",
//         });
//       })
//       .catch((err) => {
//         console.error(err);
//         console.log(err.response);
//         setSuccessMessage("");
//         setErrorMessage("User already exists...");
//       });
//   };

//   return (
//     <div>
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="main">
//           <div
//             className=" auth-inner d-flex bg-light my-element justify-content-center align-items-center mt-2"
//             style={{ height: "80%", width: "40vw" }}
//           >
//             <div className="w-100 rounded p-3">
//               <form onSubmit={handleSubmit}>
//                 <h2 style={{ marginBottom: "5%" }} className=" gradient-text">Add User</h2>
//                 {successMessage && (
//                   <div className="alert alert-success" role="alert">
//                     {successMessage}
//                   </div>
//                 )}
//                 {errorMessage && (
//                   <div className="alert alert-danger" role="alert">
//                     {errorMessage}
//                   </div>
//                 )}
//                 <div className="mb-3 d-flex flex-column align-items-start">
//                   <label className="mb-1">Name</label>
//                   <input
//                     type="text"
//                     placeholder="Enter name"
//                     className="form-control"
//                     value={values.name}
//                     onChange={(e) =>
//                       setValues({ ...values, name: e.target.value })
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="mb-3 d-flex flex-column align-items-start">
//                   <label className="mb-1">Email</label>
//                   <input
//                     type="email"
//                     placeholder="Enter email"
//                     className="form-control"
//                     value={values.email}
//                     onChange={(e) =>
//                       setValues({ ...values, email: e.target.value })
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="mb-3 d-flex flex-column align-items-start">
//                   <label className="mb-1">Password</label>
//                   <input
//                     type="password"
//                     placeholder="Enter password"
//                     className="form-control"
//                     value={values.password}
//                     onChange={(e) =>
//                       setValues({ ...values, password: e.target.value })
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="mb-3 d-flex flex-column align-items-start">
//                   <label className="mb-1">Role</label>
//                   <select
//                     className="form-select"
//                     value={values.role}
//                     onChange={(e) =>
//                       setValues({ ...values, role: e.target.value })
//                     }
//                     required
//                   >
//                     <option value="">Select Role</option>
//                     <option value="Admin">Admin</option>
//                     <option value="HR">HR</option>
//                     <option value="Candidate">Candidate</option>
//                     <option value="Interviewer">Interviewer</option>
//                   </select>
//                 </div>
//                 <button className="btn btn-success">Submit</button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Create;
